import React from 'react';

const Padlock = ({ width = 19, height = 19, colour = '' }) => {
    return (
        <svg className={'stroke-current ' + colour} viewBox="0 0 12.782 18.933" height={height} width={width}>
            <g transform="translate(-5)">
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M5.625,16.391a5.766,5.766,0,1,0,5.766-5.766,5.766,5.766,0,0,0-5.766,5.766Z"
                    transform="translate(0 -3.849)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M16.582,8.626V4.854a4.229,4.229,0,0,0-8.457,0V8.626"
                    transform="translate(-0.962 0)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M13.75,19.519a.769.769,0,1,0,.769-.769A.769.769,0,0,0,13.75,19.519Z"
                    transform="translate(-3.128 -6.977)"
                />
                <path
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                    d="M15,21.25v2.306"
                    transform="translate(-3.609 -7.939)"
                />
            </g>
        </svg>
    );
};

export default Padlock;
